import { render, staticRenderFns } from "./PositionTable.vue?vue&type=template&id=4b421710&"
import script from "./PositionTable.vue?vue&type=script&lang=js&"
export * from "./PositionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports